import type { ComponentPropsWithRef, ReactNode } from 'react';
import { cn } from '../lib/cn';
import { inputStyles } from './input-styles';

export type InputProps = ComponentPropsWithRef<'input'> & {
  /** Right-aligned tabular digits for amounts. */
  numeric?: boolean;
  /** Unit shown inside the field on the right (€, %, ×). */
  unit?: ReactNode;
};

export function Input({ className, numeric = false, unit, ...props }: InputProps) {
  const input = (
    <input
      className={cn(
        inputStyles,
        numeric && 'tabular text-right',
        unit !== undefined && 'pr-6',
        className,
      )}
      {...props}
    />
  );
  if (unit === undefined) return input;
  return (
    <span className="relative block">
      {input}
      <span
        aria-hidden
        className="pointer-events-none absolute top-0 right-2 flex h-7 items-center text-sm text-text-3"
      >
        {unit}
      </span>
    </span>
  );
}

export function Textarea({ className, ...props }: ComponentPropsWithRef<'textarea'>) {
  return (
    <textarea
      className={cn(inputStyles, 'h-auto min-h-20 resize-y py-1.5', className)}
      {...props}
    />
  );
}
